import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { getColumnsTable } from '../../utils/getColumnsTable';
import ExpandedTableRow from '../ExpandedTableRow/ExpandedTableRow';

const InfoRequest = ({ record }) => {
  const [expandedRowKeys, setExpandedRowKeys] = useState([record?.id]);

  const handleTableRowExpand = (expanded, record) => {
    if (expanded) {
      setExpandedRowKeys([record.id]);
    } else {
      setExpandedRowKeys([]);
    }
  };

  const columns = getColumnsTable();

  useEffect(() => {
    return () => {
      setExpandedRowKeys([]);
    };
  }, []);

  return (
    <Table
      size="middle"
      className={'dspxRequestsTable'}
      rowKey="id"
      expandedRowKeys={expandedRowKeys}
      // onExpand={handleTableRowExpand}
      expandRowByClick={true}
      rowClassName={() => 'dspx-table-row'}
      expandedRowRender={(record, index, indent, expanded) => (
        <ExpandedTableRow
          record={record}
          index={index}
          indent={indent}
          expanded={expanded}
        />
      )}
      expandIconAsCell={false}
      columns={columns}
      dataSource={[record]}
      pagination={false}
    />
  );
};

export default InfoRequest;
